export function textWithEllipse(text: string, length: number = 100): string {
  if (!text) return '';
  return text?.length > length ? `${text.substring(0, length)}...` : text;
}

export function asPx(value: number) {
  return `${value || 0}px`;
}

export function escape(text: string): string;
export function escape(text: number): number;
export function escape(text: undefined): string;
export function escape(text: string | number | undefined) {
  if (!text) {
    return '';
  }

  let newtext = text;
  if (typeof text === 'string') {
    newtext = text
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
  return newtext;
}
